export default "__VITE_ASSET__CpuBUAUt__"